import type { ReactNode } from 'react';
import { PublicOrgSubpageHero } from '@/components/public/PublicOrgSubpageHero';
import { useOrgPublicProfile } from '@/contexts/OrgPublicProfileContext';
import { cn } from '@/lib/utils';

interface PublicOrgMemberPageProps {
  title: string;
  backTo?: string;
  backLabel?: string;
  description?: string;
  actions?: ReactNode;
  contentClassName?: string;
  children: ReactNode;
}

/** Content wrapper for authenticated member pages inside the public org shell. */
export function PublicOrgMemberPage({
  title,
  backTo,
  backLabel = 'Back',
  description,
  actions,
  contentClassName,
  children,
}: PublicOrgMemberPageProps) {
  const { profile } = useOrgPublicProfile();
  const headingId = `${title.toLowerCase().replace(/\s+/g, '-')}-hero-heading`;
  const backLink = backTo ? { to: backTo, label: backLabel } : undefined;

  return (
    <>
      <PublicOrgSubpageHero
        title={title}
        bannerUrl={profile?.organization.bannerUrl}
        headingId={headingId}
        backLink={backLink}
      >
        {description ? (
          <p className="mt-3 max-w-2xl text-sm text-white/85 sm:text-base">{description}</p>
        ) : null}
      </PublicOrgSubpageHero>

      <div className="bg-muted/30">
        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:py-10">
          {actions ? <div className="mb-6 flex justify-end">{actions}</div> : null}
          <div className={cn(contentClassName)}>{children}</div>
        </div>
      </div>
    </>
  );
}
